import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../store/auth'
import HomeView from '../views/HomeView.vue'
import LoginBridgeView from '../views/LoginBridgeView.vue'
import { buildSsoLoginUrl } from '../utils/sso'

const routes = [
  { path: '/account-management', component: () => import('../views/AccountManagementView.vue') },
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/login',
        name: 'login',
        component: LoginBridgeView,
        meta: { isAuthBridge: true }
    },
    {
        path: '/login-complete',
        name: 'login-complete',
        component: LoginBridgeView,
        props: { completion: true },
        meta: { isAuthBridge: true }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash, top: 70, behavior: 'smooth' }
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    if (!to.meta.isAuthBridge) {
        try {
            await authStore.initializeAuth()
        } catch (error) {
            console.error('初始化登录状态失败:', error)
        }
    } else {
        try {
            await authStore.fetchAuthConfig()
        } catch (error) {
            console.error('加载账号中心配置失败:', error)
        }
    }

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        window.location.href = buildSsoLoginUrl(to.fullPath)
        return
    } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
        next({ name: 'home' })
    } else {
        next()
    }
})

export default router
